import React from "react";
import { useLocalStore, useObserver } from "mobx-react";
import { Form } from "@components/formx";
import { Spinner } from "@components";
import { useNavigation } from "@navigation";
import { CustomerEditorStore } from "./CustomerEditorStore";
import CustomerForm from "./CustomerForm";
import { FormData } from "./utils";

type Props = {
  id?: string;
  initialData?: Partial<FormData>;
  onClose?: () => void;
};

export function CustomerEditor(props: Props) {
  const navigation = useNavigation();
  const localStore = useLocalStore(
    () => new CustomerEditorStore(navigation, props.id, props.initialData)
  );

  return useObserver(() => {
    if (localStore.loading) {
      return <Spinner />;
    }

    return (
      <Form store={localStore}>
        <CustomerForm store={localStore} onClose={props.onClose} />
      </Form>
    );
  });
}
